<template>
	<div class="flex-1 flex items-top justify-between">
		<div class="flex-grow">
			<transition name="zoomin">
				<div
					v-if="showFlashMessage"
					class="py-1.5 pr-2 pl-4 rounded-b-xl text-white font-medium flex items-center shadow-md"
					:class="[
						flashMessageType == 'success'
							? 'bg-green-400 text-white'
							: 'bg-orange-400 text-white',
					]"
				>
					<ui-icon
						class="mr-2 h-5 w-5"
						:name="flashMessageType == 'success' ? 'check' : 'alert-triangle'"
						stroke-width="2"
					/>

					<span>{{ flashMessage }}</span>
				</div>
			</transition>
		</div>

		<div class="flex px-2 items-center md:ml-2 space-x-2">
			<ui-button
				v-if="isSudo"
				v-on:click="$inertia.visit($route('sudo.return'))"
				label="Exit Session"
			/>

			<layout-unread-messages-link class="block md:hidden" />

			<!-- Help -->
			<a
				:href="helpLink"
				class="max-w-xs bg-white flex items-center focus:text-green font-medium rounded-lg p-2 hover:bg-gray-100"
			>
				<ui-icon
					class="sm:mr-2 flex-shrink-0 h-6 w-6 md:h-5 md:w-5"
					name="help-circle"
					stroke-width="2"
				/>
				<span class="hidden sm:inline">{{ __("Help") }}</span>
			</a>

			<!-- Profile dropdown -->

			<ui-dropdown
				dropdown-class="right-0 origin-top-right absolute mt-0 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10 overflow-hidden"
				button-class="max-w-xs bg-white flex items-center text-gray-700 font-medium focus:text-gray-900 active:text-gray-900 rounded-lg p-2 hover:bg-gray-100"
			>
				<template v-slot:button>
					<span class="sr-only">{{ __("Open dropdown") }}</span>
					<ui-icon
						class="sm:mr-2 flex-shrink-0 h-6 w-6 md:h-5 md:w-5"
						name="user"
						stroke-width="2"
					/>
					<span class="hidden sm:inline truncate">{{ user.company_name }}</span>
				</template>

				<template v-slot:items>
					<!-- Active: "bg-gray-100", Not Active: "" -->
					<button
						v-on:click="
							$bus.$emit(
								'toggle-iframe-modal',
								$route('user.index', { iframe_modal: 1 })
							)
						"
						type="button"
						class="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900"
						role="menuitem"
						tabindex="-1"
						id="user-menu-item-0"
					>
						{{ __("User profile") }}
					</button>

					<inertia-link
						:href="logoutLink"
						method="post"
						as="button"
						class="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900"
						role="menuitem"
						tabindex="-1"
						id="user-menu-item-2"
						>{{ __("Logout") }}</inertia-link
					>
				</template>
			</ui-dropdown>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			user: this.$inertia.page.props.user,
			isSudo: this.$inertia.page.props.acl.is_sudo,
			showFlashMessage: false,
			showUserEditModal: false,
		};
	},
	computed: {
		logoutLink() {
			return window.baseUrl + "/logout";
		},
		helpLink() {
			return window.baseUrl + "/help";
		},
		flashMessage() {
			return this.$inertia.page.props.flash_message;
		},
		flashMessageType() {
			return this.$inertia.page.props.flash_type;
		},
		goToLegacy() {
			window.location = "//legacy.cropspot.com";
		},
	},
	watch: {
		flashMessage: {
			deep: true,
			immediate: true,
			handler(v) {
				if (!this.showFlashMessage) {
					return;
				}
				this.showFlashMessage = true;
				let that = this;
				setTimeout(function () {
					//that.showFlashMessage = false;
				}, 3000);
			},
		},
	},
};
</script>
